<template>
    <DialogTitle v-bind="forwardedProps" :class="cn('my-0 h3 uppercase', props.class)">
        <slot />
    </DialogTitle>
</template>
<script setup lang="ts">
import { type HTMLAttributes, computed } from "vue";
import { DialogTitle, type DialogTitleProps, useForwardProps } from "reka-ui";

const props = defineProps<DialogTitleProps & { class?: HTMLAttributes["class"] }>();

const delegatedProps = computed(() => {
    const { class: _, ...delegated } = props;

    return delegated;
});

const forwardedProps = useForwardProps(delegatedProps);
</script>
